<template>
  <div class="flex flex-col gap-3.5 p-4 pr-0 pt-2 font-sans text-base">
    <Headline class="min-w-[240px] pr-12" look="h4" tag="span">
      {{ headline }}
    </Headline>
    <div class="flex flex-col">
      <div>{{ store.street }}</div>
      <div>{{ `${store.zip} ${store.city}` }}</div>
      <div class="flex">
        <div class="ml-[-3px] flex flex-col justify-center">
          <LazyIconFielmannPin class="mr-1 size-4" />
        </div>
        <div class="flex flex-col justify-center">
          {{ store.distance.toFixed(2) }} km
        </div>
      </div>
      <StoreStatus :opening-details="store" />
    </div>
    <div class="mt-4">
      <FimButton
        :id="`store-${store.id}`"
        class="w-full"
        type="secondary"
        :to="detailsUrl"
        @mousedown="onClick"
      >
        <template #icon>
          <LazyIconFielmannStore class="size-6" />
        </template>
        {{ $t('store_finder.more_info') }}
      </FimButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IStore } from '~/rpcMethods/stores'

const props = defineProps({
  store: {
    type: Object as PropType<IStore>,
    required: true,
  },
})

const emit = defineEmits<{
  (e: 'click:link', value: MouseEvent): void
}>()

const { $fimLocalePath, $i18n } = useNuxtApp()

const onClick = (e: MouseEvent) => {
  emit('click:link', e)
}

const headline = computed(() => getStoreHeadline(props.store, $i18n))

const detailsUrl = computed(() => {
  return getStoreUrl(props.store, $fimLocalePath)
})
</script>

<style lang="scss">
.gm-style-iw-t {
  button[title='Close'] {
    top: 15px !important;
    width: 36px !important;
    height: 36px !important;

    span {
      width: 20px !important;
      height: 20px !important;
    }
  }
}

.gm-style .gm-style-iw-c {
  border-radius: 2px !important;
}
</style>
